import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class NumberUtil {

    constructor(
    
    ) { }

    round( val: string | number ): number
    {
        if ( !this.isNumber(val) ) return 0
        return Math.round(( (val as number) + Number.EPSILON) * 100) / 100
    }

    isNumber( a: any ) {

        if (typeof a === "number") return true // we only process strings!  

        if (typeof a === "string") return !isNaN(parseFloat(a)) // we only process strings!  
    }
      
}
